export default __webpack_public_path__ + "static/media/passion-made-possible.c65d67a5.jpg";